<script setup></script>

<template>
    <slot></slot>
</template>

<style scoped></style>
